import { authTokenStorage } from './authTokenStorage'
import { checkTokenValidity } from './checkTokenValidity'

export const getIsLoggedIn = () => checkTokenValidity(authTokenStorage.getToken() || undefined)
